import hexRgb from "hex-rgb";
export var rgba = function rgba(hex, alpha) {
    var rgb = hexRgb(hex, {
        format: "array"
    }).slice(0, -1).join(",");
    return "".concat(rgb, ",").concat(alpha);
};
